var React = require('react');

function IconMenuInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.46 5H.54C.24 5 0 4.78 0 4.5S.24 4 .54 4h11.92c.3 0 .54.22.54.5s-.24.5-.54.5zm0 3c.3 0 .54.22.54.5s-.24.5-.54.5H.54C.24 9 0 8.78 0 8.5S.24 8 .54 8h11.92zm0-8c.3 0 .54.22.54.5s-.24.5-.54.5H.54C.24 1 0 .78 0 .5S.24 0 .54 0h11.92z","fill":"currentColor","fillRule":"nonzero"}));
}

IconMenuInline.defaultProps = {"viewBox":"0 0 13 9"};

module.exports = IconMenuInline;

IconMenuInline.default = IconMenuInline;
